import { useQuery, useMutation } from '@tanstack/react-query';
import { getLogs, exportLogs } from '@/api/endpoints/logs';
import type { LogLevel } from '@/types/log.types';
import { salvarArquivo } from '@/lib/arquivos';

interface UseLogsOptions {
  deviceId?: string;
  level?: LogLevel;
  dateRange?: {
    start: string;
    end: string;
  };
  page?: number;
  limit?: number;
}

export const useLogs = (options?: UseLogsOptions) => {
  return useQuery({
    queryKey: ['logs', options],
    queryFn: () => getLogs(options),
    staleTime: 1000 * 60,
    retry: 1,
  });
};

export const useExportLogs = () => {
  return useMutation({
    mutationFn: (params?: UseLogsOptions) => exportLogs(params),
    onSuccess: (blob) => {
      void salvarArquivo(blob, `logs-${new Date().toISOString()}.csv`);
    },
  });
};
